export { default } from './SinglePost'
